import { MutableRefObject, useRef } from 'react';

import { NwAuthAPIServiceTypes } from '../../services/NwAuthServices/APIService';
import { NwAuthAPIService } from '../../services/NwAuthServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

const useNwAuthAPIService = () => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useAccountsRefreshAuthTokens();
  const NwAuthAPIRef: MutableRefObject<NwAuthAPIServiceTypes | null> =
    useRef(null);

  if (NwAuthAPIRef.current === null) {
    NwAuthAPIRef.current = new NwAuthAPIService(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return {
    nwAuthAPIService: NwAuthAPIRef.current
  };
};

export { useNwAuthAPIService };
